import { useContext } from 'solid-js';
import { ImageLinkCard } from '../image-link-card/image-link-card';
import { getImageUrlByIndex } from './helpers';
import LogoImage from '/client/assets/images/logo.png';
import {
    StyledCategoryLinksContainer,
    StyledCropTypeCategoriesContainer,
    StyledHeaderLogo,
    StyledStartPageHeadline,
    StyledTopContent,
    StyledButtonLink,
    StyledStartPageLinksContainer,
    StyledDesktopOnlyDiv,
} from './start.styles';
import { GrowthStages } from './growth-stages/growth-stages';
import { Disclaimer } from './disclaimer';
import { DocumentSignedNotice } from './document-signed-notice';
import { AppContext } from '../../app-context-provider/app-context-provider';

export const Start = () => {
    const { setIsSearchOpen } = useContext(AppContext);

    return (
        <StyledCropTypeCategoriesContainer>
            <StyledTopContent>
                <StyledHeaderLogo>
                    <img src={LogoImage} alt="Gullviks logotyp" height={240} width={404} />
                </StyledHeaderLogo>

                <StyledStartPageHeadline>Gullvikspraktikan</StyledStartPageHeadline>

                <StyledCategoryLinksContainer>
                    <ImageLinkCard
                        imageUrl={getImageUrlByIndex(0)}
                        name="Produkter"
                        href="/kategorier"
                        bottomBackgroundColor="green"
                    />
                    <ImageLinkCard
                        imageUrl={getImageUrlByIndex(1)}
                        name="Regkollen"
                        href="/regkoll"
                        bottomBackgroundColor="red"
                    />
                    <ImageLinkCard
                        imageUrl={getImageUrlByIndex(2)}
                        name="Rekommendationer"
                        href="/strategier"
                        bottomBackgroundColor="red"
                    />
                    <ImageLinkCard
                        imageUrl={getImageUrlByIndex(3)}
                        name="Kontakta Oss"
                        href="/kontakta-oss"
                        bottomBackgroundColor="blue"
                    />
                </StyledCategoryLinksContainer>

                <StyledStartPageLinksContainer>
                    <StyledDesktopOnlyDiv />
                    <div>
                        <StyledButtonLink
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                setIsSearchOpen(true);
                            }}
                        >
                            Sök gröda, mål eller produkt
                        </StyledButtonLink>
                        <StyledButtonLink href="/regkoll">Regkollen</StyledButtonLink>
                        <StyledButtonLink href="/daggrader">Daggrader</StyledButtonLink>
                        <StyledButtonLink href="/blandningstabeller">Blandningstabeller</StyledButtonLink>
                        <StyledButtonLink href="/upma">UPMA</StyledButtonLink>
                        <StyledButtonLink target='_blank' href="https://www.datalogisk.se/berner/">Digital sprutjournal Näsgård</StyledButtonLink>
                        <Disclaimer />
                    </div>
                    <StyledDesktopOnlyDiv />
                </StyledStartPageLinksContainer>
            </StyledTopContent>
            <GrowthStages />
            <DocumentSignedNotice />
        </StyledCropTypeCategoriesContainer>
    );
};
